export const IconChevronDown = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M4.793 8.543a1 1 0 0 1 1.414 0L12 14.336l5.793-5.793a1 1 0 1 1 1.414 1.414l-5.793 5.793a2 2 0 0 1-2.828 0L4.793 9.957a1 1 0 0 1 0-1.414"
        clipRule="evenodd"
      />
    </svg>
  );
};
